import { Component, OnInit } from '@angular/core';
import { GlobalService } from 'src/app/global.service';
import { HttpService } from 'src/app/http.service';

@Component({
  selector: 'app-reopen-sale',
  templateUrl: './reopen-sale.component.html',
  styleUrls: ['./reopen-sale.component.scss']
})
export class ReopenSaleComponent implements OnInit {
  title = null;

  constructor(private globalService: GlobalService, private httpService: HttpService) {
    this.title = this.globalService._active_display_name;
  }

  saleOpenCalled() {
    this.httpService.openSale().subscribe((data) => {
      console.log(data);
      this.globalService.showSnakeBar('Sale Reopened');
    }, (error) => {
      console.error(error);
    });
  }

  ngOnInit() {
  }

}
